function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $component, $helpers) {
    var h = require("panel").h;
    return {
      value: (h("div", {
        "class": {
          'mp-smart-hub-alert-v2': true
        },
      }, (function() {
        var __jade_nodes = [];
        const alertColor = $attr(`alert-color`);;
        __jade_nodes = __jade_nodes.concat((alertColor) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("style", (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(`mp-detail-card { --top-color: ${alertColor}; }`);;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : undefined);
        const hasSelectedExplains = $helpers.hasSelectedExplains();;
        const explainsProperty = hasSelectedExplains ? $component.selectedExplains.property : ``;;
        const explainsPropertyValue = hasSelectedExplains ? $component.selectedExplains.propertyValue : ``;;
        __jade_nodes = __jade_nodes.concat(h("mp-detail-card", {
          "attrs": {
            'back-href': hasSelectedExplains ? $helpers.generatePermalink() : ``,
            'back-href-text': hasSelectedExplains ? `Back to anomaly` : ``,
          },
          "on": {
            'goBack': event => $helpers.handleGoBack(event),
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat((hasSelectedExplains) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat($component.child(`mp-smart-hub-explains`, {
              attrs: {
                'property': explainsProperty,
                'property-value': explainsPropertyValue
              },
              class: {
                'mp-details-first': true
              }
            }));;
            return __jade_nodes
          }).call(this)) : ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat($component.child(`mp-smart-hub-summary`, {
              attrs: {
                'utc-offset': $attr(`utc-offset`)
              },
              class: {
                'mp-details-first': true
              }
            }));
            __jade_nodes = __jade_nodes.concat(($helpers.isAnomaly()) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat($component.child(`mp-smart-hub-viz`));
              __jade_nodes = __jade_nodes.concat(($component.getAlert().hasExplains) ? ((function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat($component.child(`mp-smart-hub-explains`));;
                return __jade_nodes
              }).call(this)) : undefined);;
              return __jade_nodes
            }).call(this)) : undefined);;
            return __jade_nodes
          }).call(this)));
          __jade_nodes = __jade_nodes.concat(h("mp-share-button", {
            "attrs": {
              slot: `actions`,
              'data-text': $helpers.getShareLink()
            },
            "on": {
              share: $helpers.handleShared
            },
          }));
          __jade_nodes = __jade_nodes.concat(($helpers.showFeedback()) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("mp-smart-hub-feedback-button", {
              "attrs": {
                slot: `actions`,
                'disable': $helpers.isFeedbackDisabled()
              },
              "on": {
                change: $helpers.handleSentFeedback
              },
            }));;
            return __jade_nodes
          }).call(this)) : undefined);;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$component" in locals ? locals.$component : typeof $component !== "undefined" ? $component : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;